<div *ngIf="allLoaded" class="container"
    [ngClass]="{'ionic': useIonic,  'selectedItem' : bookingId > 0 || actionId == 'ADD' }">
    <div class="cards list" @slideInOutHorizontal>
        <mat-expansion-panel hideToggle>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <div class="esquerra">
                        <div class="title">
                            {{'BOOKINGPAGE.TITLE' | translate}}
                            <span class="count">{{filterMetadata.count}}/{{bookingsCount}}</span>
                        </div>
                    </div>
                    <div class="centre">
                        <div *ngIf="portAddressOriginDestination!=null && portAddressOriginDestination.origin!=null"
                            class="origin boleta" [ngStyle]="portAddressOriginDestination.origin.style">
                            <div class="inner-boleta">
                                <div class="skin">
                                    <div class="country">{{portAddressOriginDestination.origin.country}}</div>
                                    <div class="port">{{portAddressOriginDestination.origin.port}}</div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="portAddressOriginDestination!=null && portAddressOriginDestination.destination!=null"
                            class="destination boleta" [ngStyle]="portAddressOriginDestination.destination.style">
                            <div class="inner-boleta">
                                <div class="skin">
                                    <div class="country">{{portAddressOriginDestination.destination.country}}</div>
                                    <div class="port">{{portAddressOriginDestination.destination.port}}</div>
                                </div>
                            </div>
                        </div>
                        <shared-filter class="extrapadding" [filterstrip]="filterStatus" [showonlyactives]="true"
                            [readonly]="true"></shared-filter>
                        <shared-filter class="extrapadding" [filterstrip]="filterBookingTypes" [showonlyactives]="true"
                            [readonly]="true"></shared-filter>

                    </div>
                    <div class="dreta">
                        <input class="searchbox" placeholder="{{'SEARCH'| translate}}" type=text
                            [(ngModel)]="searchText" (ngModelChange)="this.searchTextUpdate.next($event)"
                            (focus)="onSearchFocus($event)" (click)="onSearchClick($event)">
                    </div>
                    <div class="dreta-actions">
                        <actions [actionstrip]="actions" (clickAction)="onClickAction($event)"></actions>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-expansion-panel-body>
                <div class="expansion-body">
                    <shared-port-address-origin-destination-selector-component [(value)]="portAddressOriginDestination"
                        (changeValues)="onChangeOriginDestinationSelector($event)">
                    </shared-port-address-origin-destination-selector-component>
                    <shared-filter class="extrapadding" [filterstrip]="filterStatus" (change)="filterUpdate()">
                    </shared-filter>
                    <shared-filter class="extrapadding" [filterstrip]="filterBookingTypes" (change)="filterUpdate()">
                    </shared-filter>
                </div>
            </mat-expansion-panel-body>
        </mat-expansion-panel>
        <div class="page">
            <div class="column">
                <div class="llista" [ngClass]="{'selectedItem' : bookingId > 0}">
                    <div class="overflow">

                        <shared-booking-card
                            *ngFor="let item of bookingsExactKey | filterActiveRoutes:searchText:filterMetadataExactKey  | orderbybookingdto:true; let i=index"
                            class="bookingItem activebookings"
                            [ngClass]="{'selected':selectedBooking!=null && item.bookingId==selectedBooking.bookingId}"
                            [booking]="item" [isActiveRoutes]="'true'" [selectedBooking]="selectedBooking"
                            (click)="onClickItem(item)">
                        </shared-booking-card>

                        <shared-booking-card
                            *ngFor="let item of getBookings() | filterActiveRoutes:searchText:filterMetadata | filterRemoveRepeat:bookingsExactKey:'bookingId' | orderbybookingdto:true | slice:0:sliceCount; let i=index"
                            class="bookingItem activebookings"
                            [ngClass]="{'selected':selectedBooking!=null && item.bookingId==selectedBooking.bookingId}"
                            [booking]="item" [isActiveRoutes]="'true'" (click)="onClickItem(item)">
                        </shared-booking-card>

                        <button class="slice-button" (click)="onSliceMore()" *ngIf="sliceCount<itemsCount">
                            {{'GENERAL.SLICE.BUTTON' | translate:{ sliceCount: sliceCount, itemsCount:itemsCount} }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <shared-active-bookings-item class="cards one" @slideInOutHorizontal [bookingId]="bookingId" [actionId]="actionId"
        (saveNewBooking)="onSaveNewBooking($event)" (clickBack)="onClickBack($event)">
    </shared-active-bookings-item>
</div>